'use strict';

/* global $ */

let settings = {
    selector: '.js-search',
    formSelector: '.js-search__form',
    itemSelector: '.js-search__item',
    linkSelector: '.js-search__link',
    closeSelector: '.js-search__close'
};

class Search {
    constructor(options) {
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ Search/init ]');

        let $block = $(this.opt.selector),
            $form = $(this.opt.formSelector),
            $item = $(this.opt.itemSelector),
            $link = $(this.opt.linkSelector),
            $close = $(this.opt.closeSelector);
 
        $link.on('click', function(e) {
            e.preventDefault();

            $block.toggleClass('is-hidden');
            $link.toggleClass('is-active');
            $item.toggleClass('is-active');
        });

        $close.on('click', function(e) {
            e.preventDefault();

            $block.toggleClass('is-hidden');
            $link.toggleClass('is-active');
            $item.toggleClass('is-active');
        });
    }
}


export {
    Search
};
